
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';

import axios, {
	AxiosResponse,
	AxiosPromise,
	AxiosRequestConfig
} from 'axios';

import './form-check-eligibility-business.component.scss';

import * as $ from 'jquery';

export class FormCheckEligibilityBusiness extends Base {

	// service
	checkEligibility: any;

	// elements
	formCheckEligibility: HTMLFormElement;
	radioRelationship: Element[];
	radioPrimaryBusiness: Element[];
	inputDateCompany: any;
	dropdownTurnover: Element;
	dropdownEmployees: Element;
	submitButton: Element[];
	closeButton: Element;

	// containers
	containerGroupCheckEligibility: Element;
	containerUsingProducts: Element;
	containerFields: Element;
	containerButtons: Element;
	containerNote: Element;
	containerThankyou: Element;
	containerInvalid: Element;
	containerValid: Element;
	containerValidExisting: Element;
	containerModal: any;
	containerLoader: any;

	// values
	valuesJson: any;
	valueLeadType: string;
	valueClient: boolean = false;
	valueFormValid: boolean = false;
	valueNationality: string = "";
	valueResidence: string = "";
	valueModalId: string = "";
	valueDateOfBirth: string = "";

	// storage
	eligibilityStorage: any;


	constructor(element: Element, analyticsService: AnalyticsService) {
		super(element);
	}

	init() {

		this.checkEligibility = new CheckEligibility();
		this.formCheckEligibility = this.element.querySelector('form#business-check-eligibility') as HTMLFormElement;

		this.radioRelationship = Array.from(this.element.querySelectorAll('.js-existing_relationship'));
		this.inputDateCompany = this.element.querySelector('.js-date-established');
		this.radioPrimaryBusiness = Array.from(this.element.querySelectorAll('.js-primary_business'));
		this.dropdownTurnover = this.element.querySelector('.js-turnover');
		this.dropdownEmployees = this.element.querySelector('.js-employees');
		this.submitButton = Array.from(this.element.querySelectorAll('.js-check-eligibility-submit__button'));

		this.containerFields = this.element.querySelector('.form__fields--container');
		this.containerNote = this.element.querySelector('.apply-now__note');
		this.containerButtons = this.element.querySelector('.apply-now__buttons');
		this.containerThankyou = this.element.querySelector('.form__thankyou--container');
		this.containerInvalid = this.element.querySelector('.js-invalid-container');
		this.containerValid = this.element.querySelector('.js-valid-container');
		this.containerValidExisting = this.element.querySelector('.js-valid-existing-container');
		this.containerGroupCheckEligibility = this.element.querySelector('.form-check-eligibility-business__group[data-group-name=eligibility-group]');
		this.containerLoader = this.element.querySelector('.form__loader--container');

		this.containerModal = this.element.closest('.form-container');
		this.closeButton = this.containerModal.querySelector('.js-apply-now-modal-close');

		this.valuesJson = {
			operation: "open",
			category: "business",
			leadType: "Call Back_NewBusines",
			leadCTA: "CHECK ELIGIBILITY",
			eligibilityCTA: "Call Me Back",
			leadStatus: "Open",
			eligibilityFormId: "",
			clientSBG: "N",
			sbPOR: "",
			dateEstablished: "",
			primeBusinessAfrica: "",
			companyAnnualTurnover: "",
			employeesN: "",
			productName: "",
			pageUrl: ""
		}

	}

	bindEvents() {

		// radio buttons - relationship
		this.radioRelationship.map((item) => item.addEventListener('click', (event) => {
			let element: any = event.target;
			if (element.value == "no") {

				this.valuesJson.clientSBG = 'N';
				this.valuesJson.sbPOR = '';
				this.valuesJson.leadType = 'Call Back_NewBusines';

				let parentParent = element.closest('.form-check-eligibility-business__group');
				let oldInput = this.element.querySelector('.js-manager-name-container');
				parentParent.removeChild(oldInput);

			} else {
				this.valuesJson.clientSBG = 'Y';
				this.valuesJson.leadType = 'CallBack_IBB Sales';

				let parentParent = element.closest('.form-check-eligibility-business__group');
				let parent = element.closest('.form__group');

				let newContainer = document.createElement('div');
				newContainer.classList.add('form__group');
				newContainer.classList.add('js-manager-name-container');

				let newLabel = document.createElement('label');
				newLabel.classList.add('form__label');
				newLabel.innerHTML = "Standard Bank branch and relationship manager's name";
				newContainer.appendChild(newLabel);

				let newInput = document.createElement('input');
				newInput.classList.add('js-manager-name');
				newInput.classList.add('form__input');
				newInput.classList.add('form__input--required');
				newInput.setAttribute('placeholder', "Enter your Standard Bank branch and relationship manager's name");
				newContainer.appendChild(newInput);

				parentParent.insertBefore(newContainer, parent.nextSibling);
			}
		}));

		// input - date of company
		this.inputDateCompany.addEventListener('keyup', (event: any) => {
			let element: any = event.target;
			if (element.value) {
				this.valuesJson.dateEstablished = element.value;
			}
		});

		// change - date of company
		this.inputDateCompany.addEventListener('change', (event: any) => {
			let element: any = event.target;
			if (element.value) {
				this.valuesJson.dateEstablished = element.value;
			}
		});

		// radio buttons - relationship
		this.radioPrimaryBusiness.map((item) => item.addEventListener('click', (event) => {
			let element: any = event.target;
			let parent = element.closest('.form__group');
			parent.classList.remove('form__group--error');
			if (element.value == "no") {
				this.valuesJson.primeBusinessAfrica = 'N';
			} else {
				this.valuesJson.primeBusinessAfrica = 'Y';
			}
		}));

		// dropdown nationality
		this.dropdownTurnover.addEventListener('change', (event) => {
			let element: any = event.target;
			this.valuesJson.companyAnnualTurnover = element.value;
		});

		// dropdown nationality
		this.dropdownEmployees.addEventListener('change', (event) => {
			let element: any = event.target;
			this.valuesJson.employeesN = element.value;
		});

		// submit button
		this.submitButton.map((item) => item.addEventListener('click', (event) => {

			let formModal = this.element.closest('.js-apply-now-modal');
			this.valueModalId = formModal.getAttribute('id');

			const formFields: any = this.containerGroupCheckEligibility.querySelectorAll('input, select');
			let validation: any = this.validationService.validate(formFields);

			if (validation.valid) {

				if (this.valuesJson.primeBusinessAfrica !== "") {

					if (this.valuesJson.clientSBG === 'Y') {

						this.applyFilters('callmeback', this.valueModalId);

					} else {

						if (this.checkEligibility.validateDateEstablished(this.inputDateCompany.value)) {

							if (this.valuesJson.primeBusinessAfrica === 'Y' && this.valuesJson.companyAnnualTurnover !== 'Less than 1 million' && this.valuesJson.employeesN !== 'Less than 10') {

								this.applyFilters('apply', this.valueModalId);

							} else {

								this.containerFields.classList.add('hidden');
								this.containerThankyou.classList.add('active');
								this.containerInvalid.classList.add('active');
								this.checkEligibility.changeButtons('contactus', this.valueModalId);

							}

						} else {

							this.containerFields.classList.add('hidden');
							this.containerThankyou.classList.add('active');
							this.containerInvalid.classList.add('active');
							this.checkEligibility.changeButtons('contactus', this.valueModalId);

						}

					}

				} else {

					this.radioPrimaryBusiness.map((item, index) => {
						let parent = item.closest('.form__group');
						parent.classList.add('form__group--error');
					});

				}

			}

		}));

		// close button - reset form
		this.closeButton.addEventListener('click', (event) => {

			this.containerInvalid.classList.remove('active');
			this.containerValid.classList.remove('active');
			this.containerValidExisting.classList.remove('active');
			$(document).find('div.js-manager-name-container').remove();

			this.containerInvalid.classList.add('form-check-eligibility-business--hidden');
			this.containerValid.classList.add('form-check-eligibility-business--hidden');
			this.containerValidExisting.classList.add('form-check-eligibility-business--hidden');

		});

		$(document).on('click', '.js-apply-now-modal-open', (event) => {
			let element = event.target;
			let type = $(element).attr('data-productname');
			let data = $(element).attr('data-text');
			if (data) {
				let dataArray = data.split(" | ");
				let dataNewFormName = "checkeligibility | wealth business | " + type;
				this.formCheckEligibility.setAttribute('data-frmcontainer', dataNewFormName);
			}
			let modal = $(element).attr('data-modal');
			this.valuesJson.pageUrl = window.location.href;
			if (type) {
				this.valuesJson.productName = type;
			}
			if (modal) {
				this.valuesJson.eligibilityFormId = modal;
			}
			this.formstart();
		});

	}

	applyFilters(type, modalId) {

		let typeValue = type;
		let modalIdValue = modalId;

		let containerLoader = this.containerLoader;
		let containerValidExisting = this.containerValidExisting;
		let containerThankyou = this.containerThankyou;
		let containerFields = this.containerFields;
		let containerValid = this.containerValid;
		let checkEligibility = this.checkEligibility;

		containerFields.classList.add('hidden');
		containerLoader.classList.add('active');

		// variables
		let response = 'invalid';

		// fields
		let operation: any = this.valuesJson.operation;
		let category: any = this.valuesJson.category;
		let leadType: any = this.valuesJson.leadType;
		let leadCTA: any = this.valuesJson.leadCTA;
		let eligibilityCTA: any = this.valuesJson.eligibilityCTA;
		let leadStatus: any = this.valuesJson.leadStatus;
		let eligibilityFormId: any = this.valuesJson.eligibilityFormId;
		let clientSBG: any = this.valuesJson.clientSBG;
		let sbPOR: any = '';
		if (this.element.querySelector('input.js-manager-name')) {
			let component: any = this.element.querySelector('input.js-manager-name');
			console.log(component);
			sbPOR = component.value;
		}
		let dateEstablished: any = this.valuesJson.dateEstablished;
		let primeBusinessAfrica: any = this.valuesJson.primeBusinessAfrica;
		let companyAnnualTurnover: any = this.valuesJson.companyAnnualTurnover;
		let employeesN: any = this.valuesJson.employeesN;
		let productName: any = this.valuesJson.productName;
		let pageUrl: any = this.valuesJson.pageUrl;

		// build string
		let postData = '';
		if (operation) {
			postData += 'operation=' + operation + '&';
		}
		if (category) {
			postData += 'category=' + category + '&';
		}
		if (leadType) {
			postData += 'leadType=' + leadType + '&';
		}
		if (leadCTA) {
			postData += 'leadCTA=' + leadCTA + '&';
		}
		if (eligibilityCTA) {
			postData += 'eligibilityCTA=' + eligibilityCTA + '&';
		}
		if (leadStatus) {
			postData += 'leadStatus=' + leadStatus + '&';
		}
		if (eligibilityFormId) {
			postData += 'eligibilityFormId=' + eligibilityFormId + '&';
		}
		if (clientSBG) {
			postData += 'clientSBG=' + clientSBG + '&';
		}
		if (sbPOR) {
			postData += 'sbPOR=' + sbPOR + '&';
		}
		if (dateEstablished) {
			let date = new Date(dateEstablished);
			var DD = (date.getDate() <= 9 ? '0' : '') + date.getDate();
			var MM = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
			var YYYY = date.getFullYear();
			let value = DD + '/' + MM + '/' + YYYY;
			postData += 'dateEstablished=' + value + '&';
		}
		if (primeBusinessAfrica) {
			postData += 'primeBusinessAfrica=' + primeBusinessAfrica + '&';
		}
		if (companyAnnualTurnover) {
			postData += 'companyAnnualTurnover=' + companyAnnualTurnover + '&';
		}
		if (employeesN) {
			postData += 'employeesN=' + employeesN + '&';
		}
		if (productName) {
			postData += 'productName=' + productName + '&';
		}
		if (pageUrl) {
			postData += 'pageUrl=' + pageUrl + '&';
		}

		// config
		let analyticsService = new AnalyticsService();
		let url = "/services/SubmitWINLead.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		axios.post(url, postData, config).then(function (response) {

			if (response.data === 'invalid') {
				analyticsService.dtmRecordSiteError('noerrorcode|invalid fields|' + url);
				containerLoader.classList.remove('active');
				containerFields.classList.remove('hidden');
				checkEligibility.changeButtons(typeValue, modalId, '');
			} else {

				response = response.data;
				containerLoader.classList.remove('active');

				if (type === 'callmeback') {

					containerValidExisting.classList.add('active');
					containerThankyou.classList.add('active');
					containerFields.classList.add('hidden');

				} else if (type === 'apply') {

					containerValid.classList.add('active');
					containerThankyou.classList.add('active');
					containerFields.classList.add('hidden');

				}

				checkEligibility.changeButtons('callmeback', modalIdValue, response);
			}
			analyticsService.dtmFormComplete('complete', 'Submitted');

		}).catch(function (response) {
			// service failed
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);

		});

	}

	resetForm() {
		if (this.formCheckEligibility) {
			this.formCheckEligibility.reset();
			let formContainerLoader = this.element.querySelector('.form__loader--container');
			let formContainerFields = this.element.querySelector('.form__fields--container');
			let formContainerThankyou = this.element.querySelector('.form__thankyou--container');
			formContainerThankyou.classList.remove('active');
			formContainerFields.classList.remove('hidden');
		}
	}

	formstart() {

		let dataNewFormName = "checkeligibility | wealth business | " + this.valuesJson.productName;
		this.analyticsService.dtmFormNameUpdate(dataNewFormName);
		this.analyticsService.dtmAllowFormRefresh();

	}

}



// WEBPACK FOOTER //
// ./components/form-check-eligibility-business/form-check-eligibility-business.component.ts